import React from "react";
import Header from "../Header/Header";
import Footer from "./Footer";
import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <div style={{ color: "var(--primary-color)" }}>
              CODEFFI - Privacy Policy
            </div>
            <h1>Privacy Policy</h1>
            <div className="sub-info">
              <p>
                Our Privacy Policy explains how we collect, use, disclose, and
                protect your information when you use our website and services.
                We value your privacy and are committed to safeguarding your
                personal data.
              </p>
            </div>
          </div>

          <h4>Applicable To</h4>
          <p>
            This privacy policy applies to all users of our website and
            services.
          </p>

          <h4 className="mt-5">How We Collect Data</h4>
          <p>
            We collect data through forms, cookies, and user interactions on our
            platform.
          </p>

          <h4 className="mt-5">Why We Collect Your Data Once You Permit?</h4>
          <p>
            We collect data to improve user experience, provide better services,
            and personalize content.
          </p>

          <h4 className="mt-5">How Your Data is Secure?</h4>
          <p>
            We implement strict security measures to protect your data from
            unauthorized access or breaches.
          </p>

          <h4 className="mt-5">Do We Share Your Personal Data?</h4>
          <p>
            We do not sell your personal data but may share it with trusted
            third parties for service enhancements.
          </p>

          <h4 className="mt-5">How Do We Protect Your Information?</h4>
          <p>
            We use encryption, secure servers, and access controls to protect
            your data.
          </p>

          <h4 className="mt-5">Authority Provided To You</h4>
          <p>
            You have the authority to manage your data, including updating or
            deleting it upon request.
          </p>

          <h4 className="mt-5">What rights you have over your data</h4>
          <p>
            You have the right to access, modify, or request deletion of your
            personal data.
          </p>

          <h4 className="mt-5">Where Codeffi send your data</h4>
          <p>
            Your data may be processed and stored in secure locations worldwide,
            in compliance with legal requirements.
          </p>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
